<template>
    <v-app id="empty">
      <v-main>
       <v-container fluid>
       </v-container>
      </v-main>
      <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main"/>
    </v-app>
  </template>
  
  <script>
   import navBar from "@/components/ui/navbars/navbar.vue";
   export default {
    components: {
        navBar
    },
    data() {
      return {
      }  
    }
  };
  
  </script> 
  